module.exports = __webpack_public_path__ + "img/ic_myssl_border_blk.18791728.svg";